import styled from 'styled-components'

export const VerticalRadioStyle = styled.div`
  cursor: pointer;
  
  margin: ${props => props.new ? '15px 0px' : 0};
  border-bottom: ${props => props.new && props.borderBtm ? `1px solid ${props.theme.Gray90}` : 0};
  padding-bottom: ${props => props.new && props.borderBtm ? '15px' : 0};
`
